'use es6';

import { createAction } from '@reduxjs/toolkit';
import { DISMISS_CONSENT_TO_COMMUNICATE_ERROR } from '../constants/ActionTypes';
export const clickedDismissConsentToProcessError = createAction(DISMISS_CONSENT_TO_COMMUNICATE_ERROR);
export function dismissConsentToProcessError() {
  return dispatch => {
    dispatch(clickedDismissConsentToProcessError());
  };
}